import { render, staticRenderFns } from "./KnAnnouncementCard.vue?vue&type=template&id=5cc0cb30&scoped=true"
import script from "./KnAnnouncementCard.js?vue&type=script&lang=js&external"
export * from "./KnAnnouncementCard.js?vue&type=script&lang=js&external"
import style0 from "./KnAnnouncementCard.vue?vue&type=style&index=0&id=5cc0cb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc0cb30",
  null
  
)

export default component.exports